<template>
  <el-card shadow="never" class="gps-card reveal">
    <template #header>
      <div class="flex items-center justify-between flex-wrap gap-3">
        <div>
          <div class="flex items-center gap-2">
            <i class="mdi mdi-map-marker-radius gps-icon" aria-hidden="true"></i>
            <span class="font-display font-bold text-profissa-text-main">Monitoring GPS — Arrivées hors zone</span>
            <span class="info-badge">{{ gpsAlerts.length }}</span>
          </div>
          <div class="text-xs text-profissa-text-muted font-semibold mt-1">
            Signaux de qualité GPS. Ces alertes n'affectent pas le score de risque des artisans.
          </div>
        </div>
      </div>
    </template>

    <el-empty
      v-if="!isLoading && !gpsAlerts.length"
      description="Aucune alerte d'arrivée hors zone"
    />

    <el-table
      v-else
      v-loading="isLoading"
      :data="paginated"
      class="custom-table w-full"
      stripe
    >
      <el-table-column label="Artisan" min-width="160">
        <template #default="{ row }">
          <div class="font-bold text-[0.9rem]">{{ row.artisan_name || '—' }}</div>
          <div class="text-xs text-profissa-text-muted font-mono mt-0.5">{{ row.artisan_phone || '' }}</div>
        </template>
      </el-table-column>

      <el-table-column label="Date" width="150" sortable :sort-method="(a, b) => new Date(a.created_at) - new Date(b.created_at)">
        <template #default="{ row }">
          <span class="text-xs text-profissa-text-muted">{{ fmtDate(row.created_at) }}</span>
        </template>
      </el-table-column>

      <el-table-column label="Détails" min-width="220">
        <template #default="{ row }">
          <template v-if="parseDetails(row)">
            <div v-if="parseDetails(row).distance_meters !== undefined" class="text-sm">
              <span class="text-profissa-text-muted">Distance : </span>
              <span class="font-bold text-profissa-text-main">{{ parseDetails(row).distance_meters }} m</span>
            </div>
            <div v-else-if="parseDetails(row).distance !== undefined" class="text-sm">
              <span class="text-profissa-text-muted">Distance : </span>
              <span class="font-bold text-profissa-text-main">{{ parseDetails(row).distance }} m</span>
            </div>
            <div v-else class="text-xs text-profissa-text-muted italic">
              {{ JSON.stringify(parseDetails(row)).slice(0, 80) }}
            </div>
          </template>
          <span v-else class="text-profissa-text-dim">—</span>
        </template>
      </el-table-column>
    </el-table>

    <div v-if="gpsAlerts.length > pageSize" class="flex justify-end mt-6">
      <el-pagination
        v-model:current-page="currentPage"
        :page-size="pageSize"
        :total="gpsAlerts.length"
        layout="prev, pager, next, total"
        background
      />
    </div>
  </el-card>
</template>

<script setup>
import { ref, computed, watch, defineProps } from 'vue'
import { fmtDate } from '../../utils/labels'

const props = defineProps({
  alerts:    { type: Array,   default: () => [] },
  isLoading: { type: Boolean, default: false },
})

const currentPage = ref(1)
const pageSize    = 10

const gpsAlerts = computed(() =>
  props.alerts.filter(a => a.type === 'arrival_out_of_zone')
)

watch(gpsAlerts, () => { currentPage.value = 1 })

const paginated = computed(() => {
  const start = (currentPage.value - 1) * pageSize
  return gpsAlerts.value.slice(start, start + pageSize)
})

const parseDetails = (alert) => {
  if (!alert.details) return null
  try {
    const d = typeof alert.details === 'string' ? JSON.parse(alert.details) : alert.details
    return (d && typeof d === 'object') ? d : null
  } catch { return null }
}
</script>

<style scoped>
.gps-card {
  border-color: rgba(59, 130, 246, 0.2);
}

.gps-icon {
  font-size: 1.1rem;
  color: #3b82f6;
}

.info-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 1.5rem;
  height: 1.5rem;
  padding: 0 0.375rem;
  border-radius: 9999px;
  font-size: 0.7rem;
  font-weight: 800;
  background: rgba(59, 130, 246, 0.12);
  border: 1px solid rgba(59, 130, 246, 0.3);
  color: #3b82f6;
}
</style>
